import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { AgGridColumnType, AgGridExportType, ExportedColDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import IncidentRenderer from '@/cellRenderers/common/IncidentRenderer.vue'
import AttachmentCountRenderer from '@/cellRenderers/common/AttachmentCountRenderer.vue'

export const shipmentsGridPendingToReceiveColumnDefs: (ColDef | ExportedColDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('shipments.grid.elementNumber'),
        field: 'shipmentRequest.entityLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 80
    },
    {
        headerName: i18n.tc('shipments.grid.element'),
        field: 'shipmentRequest.entityType',
        type: AgGridColumnType.SHIPMENT_CORE_ENTITY,
        exportField: 'shipmentRequest.entityType.translatedName',
        exportType: AgGridExportType.TEXT,
        minWidth: 120
    },
    {
        headerName: i18n.tc('shipments.grid.sampleType'),
        colId: 'shipmentRequest.sample.sampleType.description',
        field: 'shipmentRequest.sample.sampleType',
        type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
        exportField: 'shipmentRequest.sample.sampleType.description',
        exportType: AgGridExportType.TEXT,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.location'),
        colId: 'shipmentRequest.sample.topographicCode.description',
        field: 'shipmentRequest.sample.topographicCode',
        type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
        exportField: 'shipmentRequest.sample.topographicCode.description',
        exportType: AgGridExportType.TEXT,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.assay'),
        field: 'shipmentRequest.subportion.assay.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.status'),
        field: 'shipmentRequest.status',
        type: AgGridColumnType.SHIPMENT_REQUEST_STATUS,
        exportField: 'shipmentRequest.status.translatedName',
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.propietaryCenter'),
        colId: 'shipmentRequest.caseStudy.laboratory.labName',
        field: 'shipmentRequest.ownerLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.originCenter'),
        field: 'shipmentRequest.originLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.deliveryNoteId'),
        field: 'shipment.label',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.deliveryNoteDate'),
        field: 'shipment.sendingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.shippingAuthor'),
        colId: 'shipment.sender.normalizedFullName',
        field: 'shipment.sender.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.pathologist'),
        colId: 'shipmentRequest.caseStudy.pathologist.normalizedFullName',
        field: 'shipmentRequest.pathologist.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 180,
        flex: 1
    },
    {
        headerName: i18n.tc('grid.hasAlarms'),
        headerTooltip: i18n.tc('grid.hasAlarms'),
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-exclamation-triangle')
        },
        field: 'shipmentRequest.incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        cellRendererFramework: IncidentRenderer,
        sortable: false,
        filter: false,
        hide: false,
        maxWidth: 80
    },
    {
        headerName: i18n.tc('grid.attachments'),
        headerTooltip: i18n.tc('grid.attachments'),
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-paperclip')
        },
        field: 'shipmentRequest.attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        cellRendererFramework: AttachmentCountRenderer,
        sortable: false,
        filter: false,
        hide: false,
        maxWidth: 80
    }
]
